import AbstractUISlider from "./AbstractUISlider";
import {ELEMENT_IDS} from "../MobileDOM";
import {ACTION_EVENTS} from "../../UserAction";
import events from "../../../events/EventsObservable";
import Wallet from "../../../wallet/Wallet";

class UISliderCoin extends AbstractUISlider {

    constructor(wallet: Wallet) {
        let slider = document.getElementById(ELEMENT_IDS.SLIDER_COIN);
        let value = wallet.getCoinValue();
        let allowedValues = wallet.getAllowedCoinValues();
        let range = wallet.getCoinValues();

        super(wallet, slider, range, value, allowedValues, true);

        events.subscribe(ACTION_EVENTS.ACTION_SLIDER_COIN_ON_SET, this);
        events.subscribe(ACTION_EVENTS.ACTION_SLIDER_COIN_UPDATE, this);
    }

    notify(eventName: string, data?: any, prevData?: any): Promise<any>|void {
        switch (eventName) {
            case ACTION_EVENTS.ACTION_SLIDER_COIN_ON_SET:
                this._onSetEvent();
                break;
            case ACTION_EVENTS.ACTION_SLIDER_COIN_UPDATE:
                this.__update(data.coinValue, data.allowedCoinValues);
                break;
        }
    }

    _update({creditBet, allowedCreditBets, coinValue, allowedCoinValues}) {
        this.__update(coinValue, allowedCoinValues);
        events.dispatch(ACTION_EVENTS.ACTION_SLIDER_BET_UPDATE, {creditBet, allowedCreditBets});
    }
}

export default UISliderCoin;